<video #target class="video-js vjs-big-play-centered" playsinline></video>
